import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { ColorAnimation } from "./ColorAnimation";
export var HslAnimation = /*#__PURE__*/function () {
  function HslAnimation() {
    _classCallCheck(this, HslAnimation);
    this.h = new ColorAnimation();
    this.s = new ColorAnimation();
    this.l = new ColorAnimation();
  }
  _createClass(HslAnimation, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      this.h.load(data.h);
      this.s.load(data.s);
      this.l.load(data.l);
    }
  }]);
  return HslAnimation;
}();